import { keepPreviousData, useQuery } from "@tanstack/react-query"
import { loadNews } from "./axiosQuery/newsQuery"
import { TIME_UPDATE } from "../config"

export const useNews = () => {
    return (
        useQuery({
            queryKey: ['news'],
            queryFn: () => loadNews(),
            onError: (e) => console.log(e.message),
            staleTime: TIME_UPDATE,
            placeholderData: keepPreviousData,
            refetchOnWindowFocus: false,
        })
    )
}
